import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
  Container,
} from '@mui/material';
import {
  CheckCircle as CheckIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const AccountDeletedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        py: 4
      }}>
        <Card sx={{ width: '100%', textAlign: 'center' }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ mb: 3 }}>
              <CheckIcon 
                sx={{ 
                  fontSize: 80, 
                  color: 'success.main',
                  mb: 2
                }} 
              />
              <Typography variant="h4" component="h1" gutterBottom>
                退会完了
              </Typography>
            </Box>

            <Alert severity="success" sx={{ mb: 3 }}>
              <Typography variant="body1">
                アカウントの退会処理が完了しました。
              </Typography>
            </Alert>
        
            <Box sx={{ mb: 4 }}>
              <Typography variant="body2" color="text.secondary" paragraph>
                ご利用いただき、ありがとうございました。
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                データは管理者により適切に管理され、必要に応じて確認・処理されます。
              </Typography>
              <Typography variant="body2" color="text.secondary">
                再度ご利用いただく場合は、新規登録が必要です。
              </Typography>
            </Box>

            <Button
              variant="contained"
              size="large"
              onClick={handleGoHome}
              startIcon={<HomeIcon />}
              sx={{ px: 4 }}
            >
              ホームに戻る
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};
